import { useRive } from "@rive-app/react-canvas";
import React from "react";
export const MediaViewerComponent = ({ ...props }) => {
    const { RiveComponent } = useRive({
        autoplay: true,
        ...props
    });
    return (React.createElement(RiveComponent, null));
};
